
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function FeaturedProducts() {
  const navigate = useNavigate();
  const products = [
    {
      id: 1,
      name: 'Moringa Powder',
      tagline: 'Superfood nutrition from nature\'s green powerhouse',
      price: '₹299',
      originalPrice: '₹399',
      image: 'https://static.readdy.ai/image/9d639ef6c9792709f408f68c264ec65c/259510fa1447af2896f61d3473620b43.png',
      benefits: ['Boosts immunity & energy', 'Rich in antioxidants', '100% organic & vegan', 'Supports digestion']
    },
    {
      id: 2,
      name: 'Moringa Tablets',
      tagline: 'Daily wellness in a convenient, plant-based capsule',
      price: '₹399',
      originalPrice: '₹499',
      image: 'https://static.readdy.ai/image/9d639ef6c9792709f408f68c264ec65c/ec501008434a48d659f10ea9ddd79ab9.png',
      benefits: ['Easy daily supplement', 'Supports immunity & energy', '100% organic & chemical-free', 'Convenient on-the-go']
    }
  ];

  const handleViewAllProducts = () => {
    navigate('/products');
  };

  const handleAddToCart = () => {
    navigate('/ecom');
  };

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-8">
          <h2 className="text-4xl font-bold text-gray-900">
            Our Featured Products
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-product-shop>
          {products.map((product) => (
            <div key={product.id} className="bg-emerald-50/50 rounded-2xl p-8 hover:shadow-xl transition-shadow duration-300">
              <div className="flex flex-col md:flex-row gap-8 items-center">
                <div className="flex-shrink-0">
                  <img 
                    src={product.image}
                    alt={product.name}
                    className="w-64 h-64 object-cover rounded-xl shadow-lg"
                  />
                </div>
                
                <div className="flex-1 text-center md:text-left">
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">{product.name}</h3>
                  <p className="text-emerald-600 font-medium mb-4">{product.tagline}</p>
                  
                  <div className="flex items-center justify-center md:justify-start gap-3 mb-6">
                    <span className="text-3xl font-bold text-emerald-600">{product.price}</span>
                    <span className="text-lg text-gray-500 line-through">{product.originalPrice}</span>
                    <span className="bg-emerald-100 text-emerald-700 px-2 py-1 rounded-full text-sm font-medium">
                      25% OFF
                    </span>
                  </div>
                  
                  <ul className="space-y-2 mb-6">
                    {product.benefits.map((benefit, index) => (
                      <li key={index} className="flex items-center justify-center md:justify-start text-gray-700">
                        <i className="ri-check-line w-5 h-5 text-emerald-600 mr-2 flex-shrink-0"></i>
                        {benefit}
                      </li>
                    ))}
                  </ul>
                  
                  <Button variant="primary" size="md" className="w-full md:w-auto" onClick={handleAddToCart}>
                    Add to Cart
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Button variant="outline" size="lg" onClick={handleViewAllProducts}>
            View All Products
          </Button>
        </div>
      </div>
    </section>
  );
}
